@if (type !== 'system') {
<img [ngSrc]="message.profile.avatar" class="avatar" width="32" height="32" />
}
<div class="right">
  <div class="top">
    <div class="name">{{ message.profile.name | name }}</div>
    <app-level-new class="user-level badge badge_rounded badge_font-l" [level]="message.profile.level"></app-level-new>
    @if (type) {
    <div class="tag user-level badge badge_rounded badge_font-l">{{ type }}</div>
    }
  </div>
  <div class="message" [innerHtml]="content | name | chatEmote : message.profile.level" [class.emote-only]="isOnlyEmote()" (click)="$event.stopPropagation()"></div>
</div>
